export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";